import { useTheme } from '@mui/material';
import { mixProfiles, defaultPanMap } from './iemData';
import './IEMCheatSheet.css';

function MixCard({ name, subtitle, rows }) {
  return (
    <div className="iem-card">
      <h3 className="iem-card-title">{name}</h3>
      <p className="iem-card-subtitle">{subtitle}</p>
      <table className="iem-table">
        <thead>
          <tr>
            <th>Source</th>
            <th>Lvl</th>
            <th>Pan</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(([source, lvl, pan]) => (
            <tr key={source}>
              <td>{source}</td>
              <td>{lvl}</td>
              <td>{pan}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function IEMCheatSheet() {
  const theme = useTheme();

  return (
    <div className="iem-page" style={{ paddingTop: 'var(--nav-height)' }}>
      <header className="iem-header">
        <p className="iem-kicker">IEM Starting Mix Cheat Sheet</p>
        <h1 style={{ fontFamily: theme.typography.secondaryFontFamily }}>
          Click + Talkback Loudest &bull; Yourself Next &bull; Everything Else Only As Useful
        </h1>
        <p className="iem-intro">
          Use these as starting points, not rules. If everything is 70–100%, you have recreated
          front-of-house in your ears instead of building a useful personal mix.
        </p>
      </header>

      <section className="iem-grid">
        {mixProfiles.slice(0, 3).map((profile) => (
          <MixCard key={profile.name} {...profile} />
        ))}
      </section>

      <p className="iem-rule">
        Rule: Click / Talkback &rarr; Yourself &rarr; Primary references &rarr; Helpful background
        only.
      </p>

      <p className="iem-section-intro">
        For chordal instruments, separation matters. Pan gently so players can hear what space is
        already occupied.
      </p>

      <section className="iem-grid">
        {mixProfiles.slice(3, 6).map((profile) => (
          <MixCard key={profile.name} {...profile} />
        ))}
      </section>

      <section className="iem-grid iem-grid--closing">
        {mixProfiles.slice(6, 8).map((profile) => (
          <MixCard key={profile.name} {...profile} />
        ))}

        <div className="iem-card iem-pan-map">
          <h3 className="iem-card-title">Default Pan Map</h3>
          <table className="iem-table">
            <thead>
              <tr>
                <th>Pan</th>
                <th>Source</th>
              </tr>
            </thead>
            <tbody>
              {defaultPanMap.map(([pan, source]) => (
                <tr key={pan}>
                  <td>{pan}</td>
                  <td>{source}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <footer className="iem-footer">
        <p className="iem-footer-quote">
          Your IEM mix is not supposed to sound like the room. It is supposed to give you the
          information you need to serve your part well.
        </p>
        <p className="iem-footer-note">
          Keep pan conservative. Avoid hard-panning anything important.
        </p>
      </footer>
    </div>
  );
}
